import { render, staticRenderFns } from "./view-order.vue?vue&type=template&id=4eeea928&scoped=true&"
import script from "./view-order.vue?vue&type=script&lang=js&"
export * from "./view-order.vue?vue&type=script&lang=js&"
import style0 from "./view-order.vue?vue&type=style&index=0&id=4eeea928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeea928",
  null
  
)

export default component.exports